
import { mapGetters, mapState } from "vuex";

import { colors } from "~/colors.config";

export default {
  props: {
    styles: { type: Object, default: () => {} },
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
  },

  data: () => ({ loading: false }),

  computed: {
    ...mapState("wishlist", ["modalTypes", "customer", "fillColor"]),
    ...mapGetters("wishlist", ["getItem"]),
    wishlistItem() {
      return this.getItem(this.product.id, this.selectedVariant.id);
    },
    addPayload() {
      const metafields = {
        brand_list: this.product.brand_list,
        product_category: this.product.product_category,
      };

      return {
        product: { ...this.product, metafields },
        selectedVariant: this.selectedVariant,
      };
    },
    bgColor() {
      return colors.gray[300];
    },
  },

  methods: {
    async handleClick() {
      if (!this.customer?.email) {
        this.$store.dispatch("wishlist/openModal", {
          type: this.modalTypes.LOGIN_MODAL,
          modalOpenedFrom: "PDP",
          payload: this.addPayload,
        });
        return;
      }

      this.loading = true;
      try {
        await this.addRemoveItem();
      } catch (err) {
        this.$bugsnag.notify(err);
      } finally {
        this.loading = false;
      }
    },
    async addRemoveItem() {
      if (this.wishlistItem) {
        await this.$store.dispatch("wishlist/removeItem", {
          productId: this.product.id,
          variantId: this.selectedVariant.id,
        });
        return;
      }

      await this.$store.dispatch("wishlist/addItem", this.addPayload);
    },
  },
};
